module.exports = __webpack_public_path__ + "6f6823af4804bd623d7dd59e2df53eca.pdf";